<template>
  <div class="background">
    <Title :message="'CREW'" :isDark="false" />
    <div class="crew-container">
      <div class="crew serif">
        <img class="thumb" src="../assets/rust.png" />
        <div class="name">김민석</div>
        <div class="position sans">CEO</div>
        <div class="border"></div>
        <div class="description">
          모바일 서비스 기획과 <br>
          UI/UX 디자인, 웹툰 컨텐츠 <br>
          기획 및 제작. <br>
        </div>
      </div>
      <div class="crew serif">
        <img class="thumb" src="../assets/kang.png" />
        <div class="name">강희종</div>
        <div class="position sans">CTO</div>
        <div class="border"></div>
        <div class="description">
          서비스 기획과 마케팅<br>
          그 외 운영에 필요한<br>
          모든 프로그램 개발. <br>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from './Title.vue'
export default {
  components: {
    Title
  }
}
</script>

<style lang="scss" scoped>
.background {
  background-color: #ecedf2;
  padding-top: 52px;
  .crew-container {
    width: 80%;
    margin: auto;
    position: relative;
    padding-bottom: 52px;
    .crew {
      display: inline-block;
      width: 50%;
      .thumb {
        width: 30%;
      }
      .name {
        margin-top: 28px;
        font-weight: 800;
        font-size: 24px;
        color: #262728;
        letter-spacing: 1.2px;
      }
      .position {
        font-size: 20px;
        color: #878a8e;
        letter-spacing: -1px;
      }
      .border {
        margin: auto;
        width: 60%;
        background-color: #262728;
        height: 2px;
        margin-top: 44px;
        margin-bottom: 23px;
      }
      .description {
        font-size: 19px;
        color: #262728;
        letter-spacing: -1px
      }
    }
  }
}


@media screen and (max-width: 640px) {
  .background {
  padding-top: 32px;
  .crew-container {
    width: 100%;
    margin: auto;
    position: relative;
    .crew {
      padding-bottom: 32px;
      display: inline-block;
      width: 100%;
      .thumb {
        width: 20%;
      }
      .name {
        margin-top: 16px;
        font-size: 20px
      }
      .position {
        font-size: 16px;
        letter-spacing: -1px;
      }
      .border {
        margin: auto;
        width: 50%;
        background-color: #262728;
        height: 2px;
        margin-top: 25px;
        margin-bottom: 18px;
      }
      .description {
        font-size: 19px;
      }
    }
  }
}
}
</style>


